import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

/** يرجع كائن المحتوى المحفوظ أو null إذا لم يتم الحفظ من قبل. */
export async function fetchUnifiedMatrix() {
  const res = await fetch(`${API_BASE}/api/unifiedmatrix`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المصفوفة'));
  if (!data?.contentJson) return null;
  try {
    return JSON.parse(data.contentJson);
  } catch {
    return null;
  }
}

export async function saveUnifiedMatrix(content) {
  const res = await fetch(`${API_BASE}/api/unifiedmatrix`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify({ contentJson: JSON.stringify(content) }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر حفظ المصفوفة'));
}

export async function resetUnifiedMatrix() {
  const res = await fetch(`${API_BASE}/api/unifiedmatrix`, {
    method: 'DELETE',
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  if (res.status === 204) return;
  const data = await res.json().catch(() => ({}));
  throw new Error(messageFromErrorBody(data, 'تعذر استعادة المصفوفة الافتراضية'));
}
